<ng-container *ngIf="plotConfig; else noPlots">
  <div class="u-margin-top-20 u-margin-bottom-50">
    <div class="o-flex o-flex--align-items-center o-flex--justify-space-between u-padding-left-right-5">
      <div class="pd-wrapper_left-side-buttons o-flex o-flex--justify-space-between">
        <app-y-axis-button (click)="openYAxis2()" [disableButton]="!this.yAxis1.length" buttonName="Y 2"></app-y-axis-button>
        <app-y-axis-button (click)="openYAxis1()" buttonName="Y 1"></app-y-axis-button>
      </div>
      <div class="pd-right-side-buttons o-flex o-flex--justify-space-between">
        <app-y-axis-button (click)="onYAxis3Changed()" [disableButton]="!this.yAxis1.length" buttonName="Y 3"></app-y-axis-button>
      </div>
    </div>
    <div *ngIf="!this.yAxis1.length" class="width-49-percent u-color-red u-text-align-center u-margin-0-auto">
      <span>Here you can customize the “Performance Development Chart”. You can select the metrics you want to see on the two left Y-axis and one right Y-axis. You can also stack now up to 3 performance development charts. Start by selecting the first metric for the first Y-axis.</span>
    </div>
    <app-performance-development-chart-preview class="u-margin-bottom-15 u-display-block"  *ngIf="this.yAxis1.length" [chartType]="type" [config]="plotConfig"></app-performance-development-chart-preview>
    <app-pd-toggle-type *ngIf="this.yAxis1.length" [config]="xAxisType" (toggleChanged)="onToggleChanged($event)"></app-pd-toggle-type>
    <div *ngIf="isRemovable" class="o-flex o-flex--justify-right">
      <button mat-raised-button color="primary" (click)="removeCurrentGraph()">Remove this Graph</button>
    </div>
  </div>
  <mat-divider></mat-divider>
</ng-container>
<ng-template #noPlots>No Plots Data</ng-template>
